(function () {
  /* ---------------------------------------------------------- Carousel ---- */

  function initCarousel(root) {
    var viewport = root.querySelector('.featured-products-kuma__viewport');
    var track = root.querySelector('[data-track]');
    var prev = root.querySelector('[data-prev]');
    var next = root.querySelector('[data-next]');
    if (!viewport || !track) return;

    function getStep() {
      var card = track.querySelector('.featured-products-kuma__card');
      if (!card) return 320;
      var styles = window.getComputedStyle(track);
      var gap = parseFloat(styles.columnGap || styles.gap || '0') || 0;
      return card.getBoundingClientRect().width + gap;
    }

    function checkScrollable() {
      var overflows = track.scrollWidth > viewport.clientWidth + 1;
      viewport.classList.toggle('is-scrollable', overflows);
      updateArrows(overflows);
    }

    function updateArrows(forceOverflow) {
      if (!prev || !next) return;
      var max = viewport.scrollWidth - viewport.clientWidth;
      var overflows = typeof forceOverflow === 'boolean' ? forceOverflow : max > 1;
      prev.style.display = overflows ? '' : 'none';
      next.style.display = overflows ? '' : 'none';
      if (!overflows) return;
      var atStart = viewport.scrollLeft <= 1;
      var atEnd = viewport.scrollLeft >= max - 1;
      prev.toggleAttribute('disabled', atStart);
      next.toggleAttribute('disabled', atEnd);
      prev.setAttribute('aria-disabled', atStart ? 'true' : 'false');
      next.setAttribute('aria-disabled', atEnd ? 'true' : 'false');
    }

    if (prev) prev.addEventListener('click', function () {
      viewport.scrollBy({ left: -getStep(), behavior: 'smooth' });
    });
    if (next) next.addEventListener('click', function () {
      viewport.scrollBy({ left: getStep(), behavior: 'smooth' });
    });

    viewport.addEventListener('scroll', function () { updateArrows(); }, { passive: true });

    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(checkScrollable, 100);
    });

    checkScrollable();
    window.addEventListener('load', checkScrollable);
    setTimeout(checkScrollable, 250);
  }

  /* ---------------------------------------------------------- Quickview --- */

  var productCache = {};

  function escapeHtml(s) {
    if (s == null) return '';
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function formatMoney(cents) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      var fmt = (window.theme && window.theme.moneyFormat) || (window.Shopify.money_format) || '${{amount}}';
      try { return window.Shopify.formatMoney(cents, fmt); } catch (e) { /* fall through */ }
    }
    return '$' + (cents / 100).toFixed(2);
  }

  function fetchProduct(handle) {
    if (productCache[handle]) return Promise.resolve(productCache[handle]);
    return fetch('/products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' })
      .then(function (r) {
        if (!r.ok) throw new Error('Failed to fetch product: ' + r.status);
        return r.json();
      })
      .then(function (data) { productCache[handle] = data; return data; });
  }

  function sizedImage(url, width) {
    if (!url) return '';
    // Append _Wx variant before the extension, leaving query strings alone.
    return url.replace(/(\.[a-zA-Z]+)(\?.*)?$/, '_' + width + 'x$1$2');
  }

  function renderMeter(level, label, startStop, endStop) {
    /* Slider design (mirrors .pds-kuma__meter): a rail with a red knob (white
       Kuma bear inside) and a red glow under it. Levels run 0–5; --fpk-knob-f
       is the 0–1 fraction (level ÷ 5) that positions the knob. */
    var l = Math.max(0, Math.min(5, parseInt(level, 10) || 0));
    var f = l / 5;
    var html = '<div class="fpk-qv__meter">';
    html += '<div class="fpk-qv__meter-label">' + escapeHtml(label) + '</div>';
    html += '<div class="fpk-qv__meter-track" data-level="' + l + '" style="--fpk-knob-f:' + f + ';">';
    html += '<div class="fpk-qv__meter-glow" aria-hidden="true"></div>';
    html += '<div class="fpk-qv__meter-knob" aria-hidden="true"><span class="fpk-qv__meter-bear"></span></div>';
    html += '</div>';
    html += '<div class="fpk-qv__meter-stops">';
    html += '<span class="fpk-qv__meter-stop fpk-qv__meter-stop--start">' + escapeHtml(startStop) + '</span>';
    html += '<span class="fpk-qv__meter-stop fpk-qv__meter-stop--end">' + escapeHtml(endStop) + '</span>';
    html += '</div></div>';
    return html;
  }

  function renderProduct(modal, product, productUrl, trigger) {
    var content = modal.querySelector('[data-qv-content]');
    var firstAvailable = null;
    for (var i = 0; i < product.variants.length; i++) {
      if (product.variants[i].available) { firstAvailable = product.variants[i]; break; }
    }
    if (!firstAvailable) firstAvailable = product.variants[0];

    var img = product.featured_image || (product.images && product.images[0]) || '';
    var imgSrc = img ? sizedImage(img, 720) : '';
    var hasVariants = product.variants.length > 1;
    var sectionId = modal.getAttribute('data-qv-for');
    var titleId = 'fpk-qv-title-' + sectionId;

    var parts = [];
    parts.push('<div class="fpk-qv__media">');
    if (imgSrc) {
      parts.push('<img src="' + escapeHtml(imgSrc) + '" alt="' + escapeHtml(product.title) + '">');
    }
    parts.push('</div>');

    parts.push('<div class="fpk-qv__details">');
    parts.push('<h2 class="fpk-qv__title" id="' + titleId + '">' + escapeHtml(product.title) + '</h2>');
    if (product.vendor) {
      parts.push('<p class="fpk-qv__vendor">' + escapeHtml(product.vendor) + '</p>');
    }
    parts.push('<p class="fpk-qv__price" data-qv-price>' + formatMoney(firstAvailable.price) + '</p>');
    /* Prefer the `custom.short_description` metafield (passed in via the
       trigger's data-short-description attr from Liquid, because the
       /products/<handle>.js endpoint doesn't return metafields). Fall back
       to product.description with a 4-line clamp. Both are admin-authored
       HTML so we trust them as innerHTML. */
    /* Full description (custom.full_description metafield, passed via the
       trigger's data attr). Collapsed behind a Read more / Read less toggle.
       Admin-authored HTML, trusted as innerHTML like the short description. */
    var fullDesc = trigger ? trigger.getAttribute('data-full-description') : null;
    var fullDescHasContent = fullDesc && fullDesc.replace(/<[^>]*>/g, '').trim().length > 0;

    var shortDesc = trigger ? trigger.getAttribute('data-short-description') : null;
    var shortDescHasContent = shortDesc && shortDesc.replace(/<[^>]*>/g, '').trim().length > 0;
    if (shortDescHasContent) {
      // When there's more behind the toggle, fade the short description's
      // bottom out to the modal background (matches the PDS design).
      var shortCls = 'fpk-qv__description' + (fullDescHasContent ? ' fpk-qv__description--has-more' : '');
      parts.push('<div class="' + shortCls + '" data-qv-desc-short>' + shortDesc + '</div>');
    } else if (product.description) {
      parts.push('<div class="fpk-qv__description fpk-qv__description--clamp">' + product.description + '</div>');
    }

    if (fullDescHasContent) {
      parts.push('<div class="fpk-qv__description-full" data-qv-desc-full hidden>' + fullDesc + '</div>');
      parts.push('<button type="button" class="fpk-qv__description-toggle" data-qv-desc-toggle aria-expanded="false">Read more</button>');
    }

    /* ---- Roast / Brightness meters + Tasting notes ----
       Pulled off the trigger's data-* attrs (Liquid populated them from the
       same product metafields the PDS section reads — see featured-products-kuma.liquid). */
    if (trigger) {
      var roastLevel = trigger.getAttribute('data-roast-level');
      var brightnessLevel = trigger.getAttribute('data-brightness-level');
      var tastingNotes = trigger.getAttribute('data-tasting-notes');

      if (roastLevel && parseInt(roastLevel, 10) > 0) {
        parts.push(renderMeter(roastLevel, 'Roast Level', 'Light', 'Dark'));
      }
      if (brightnessLevel && parseInt(brightnessLevel, 10) > 0) {
        parts.push(renderMeter(brightnessLevel, 'Brightness', 'Chocolate', 'Fruity'));
      }
      if (tastingNotes && tastingNotes.length > 0) {
        parts.push('<div class="fpk-qv__notes">');
        parts.push('<div class="fpk-qv__notes-label">Tasting Notes:</div>');
        parts.push('<div class="fpk-qv__notes-divider" aria-hidden="true"></div>');
        parts.push('<div class="fpk-qv__notes-text">' + escapeHtml(tastingNotes) + '</div>');
        parts.push('</div>');
      }
    }

    if (hasVariants) {
      parts.push('<div class="fpk-qv__variants">');
      parts.push('<label class="fpk-qv__variant-label" for="fpk-qv-variant-' + sectionId + '">Variant</label>');
      parts.push('<select class="fpk-qv__variant" id="fpk-qv-variant-' + sectionId + '" data-qv-variant>');
      for (var v = 0; v < product.variants.length; v++) {
        var variant = product.variants[v];
        var selected = variant.id === firstAvailable.id ? ' selected' : '';
        var disabled = variant.available ? '' : ' disabled';
        var label = variant.title + ' — ' + formatMoney(variant.price) + (variant.available ? '' : ' (Sold out)');
        parts.push('<option value="' + variant.id + '"' + selected + disabled + '>' + escapeHtml(label) + '</option>');
      }
      parts.push('</select></div>');
    }

    parts.push('<form class="fpk-qv__form" data-qv-form>');
    parts.push('<input type="hidden" name="id" value="' + firstAvailable.id + '" data-qv-id>');
    parts.push('<div class="fpk-qv__qty" role="group" aria-label="Quantity">');
    parts.push('<button type="button" class="fpk-qv__qty-btn" data-qv-qty-step="-1" aria-label="Decrease quantity">−</button>');
    parts.push('<input type="number" name="quantity" value="1" min="1" inputmode="numeric" class="fpk-qv__qty-input" data-qv-qty-input>');
    parts.push('<button type="button" class="fpk-qv__qty-btn" data-qv-qty-step="1" aria-label="Increase quantity">+</button>');
    parts.push('</div>');
    var addLabel = firstAvailable.available ? 'Add to cart' : 'Sold out';
    var addDisabled = firstAvailable.available ? '' : ' disabled';
    parts.push('<button type="submit" class="fpk-qv__add" data-qv-add' + addDisabled + '>' + addLabel + '</button>');
    parts.push('</form>');

    parts.push('<a class="fpk-qv__link" href="' + escapeHtml(productUrl) + '">View full details &rarr;</a>');
    parts.push('</div>');

    content.innerHTML = parts.join('');

    /* ---- per-render bindings ---- */
    var variantSelect = content.querySelector('[data-qv-variant]');
    var priceEl = content.querySelector('[data-qv-price]');
    var idInput = content.querySelector('[data-qv-id]');
    var addBtn = content.querySelector('[data-qv-add]');
    var qtyInput = content.querySelector('[data-qv-qty-input]');
    var form = content.querySelector('[data-qv-form]');

    var descToggle = content.querySelector('[data-qv-desc-toggle]');
    var descFull = content.querySelector('[data-qv-desc-full]');
    var descShort = content.querySelector('[data-qv-desc-short]');
    if (descToggle && descFull) {
      descToggle.addEventListener('click', function () {
        var next = descToggle.getAttribute('aria-expanded') !== 'true';
        descFull.hidden = !next;
        descToggle.setAttribute('aria-expanded', next ? 'true' : 'false');
        // Drop the bottom fade once expanded; restore it when collapsed.
        if (descShort) descShort.classList.toggle('is-expanded', next);
        descToggle.textContent = next ? 'Read less' : 'Read more';
      });
    }

    if (variantSelect) {
      variantSelect.addEventListener('change', function () {
        var selected = null;
        for (var i = 0; i < product.variants.length; i++) {
          if (String(product.variants[i].id) === variantSelect.value) {
            selected = product.variants[i]; break;
          }
        }
        if (!selected) return;
        idInput.value = selected.id;
        priceEl.textContent = formatMoney(selected.price);
        if (selected.available) {
          addBtn.disabled = false;
          addBtn.textContent = 'Add to cart';
        } else {
          addBtn.disabled = true;
          addBtn.textContent = 'Sold out';
        }
      });
    }

    content.querySelectorAll('[data-qv-qty-step]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var step = parseInt(btn.getAttribute('data-qv-qty-step'), 10) || 0;
        var current = parseInt(qtyInput.value, 10);
        if (isNaN(current) || current < 1) current = 1;
        qtyInput.value = Math.max(1, current + step);
      });
    });

    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (addBtn.disabled) return;
        addBtn.disabled = true;
        var origLabel = addBtn.textContent;
        addBtn.textContent = 'Adding…';
        fetch('/cart/add.js', {
          method: 'POST',
          body: new FormData(form),
          credentials: 'same-origin',
          headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
        })
          .then(function (r) {
            if (!r.ok) return r.json().then(function (err) { throw err; });
            window.location.href = '/cart';
          })
          .catch(function () {
            addBtn.disabled = false;
            addBtn.textContent = origLabel;
            window.alert('Sorry, we could not add that item to your cart. Please try again.');
          });
      });
    }
  }

  function getFocusable(modal) {
    return Array.prototype.slice.call(
      modal.querySelectorAll(
        'a[href], button:not([disabled]), select:not([disabled]), input:not([disabled]):not([type="hidden"]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
      )
    );
  }

  function initQuickview(root) {
    var sectionId = root.getAttribute('data-section-id');
    if (!sectionId) return;
    var modal = document.querySelector('.fpk-qv[data-qv-for="' + sectionId + '"]');
    if (!modal) return;

    var triggers = root.querySelectorAll('[data-quickview]');
    if (!triggers.length) return;

    var lastFocus = null;

    function lockPanelHeight() {
      /* Freeze the modal at its collapsed height so expanding the full
         description scrolls inside .fpk-qv__content rather than growing the
         modal. Content is freshly rendered collapsed, and the media uses a
         fixed aspect-ratio, so the height is stable before the image loads. */
      var panel = modal.querySelector('.fpk-qv__panel');
      if (!panel) return;
      panel.style.height = '';
      /* Only freeze the height on desktop. On mobile the modal is full-screen
         and already scrolls within max-height:100vh; locking a px height there
         fights the dynamic viewport (address bar show/hide) and makes the
         layout jump and overlap. */
      if (!window.matchMedia('(min-width: 750px)').matches) return;
      requestAnimationFrame(function () {
        panel.style.height = panel.offsetHeight + 'px';
      });
    }

    function open(handle, productUrl, trigger) {
      lastFocus = document.activeElement;
      fetchProduct(handle)
        .then(function (product) {
          renderProduct(modal, product, productUrl, trigger);
          modal.hidden = false;
          document.body.classList.add('fpk-qv-open');
          lockPanelHeight();
          var closeBtn = modal.querySelector('[data-qv-close-btn]');
          if (closeBtn) closeBtn.focus();
        })
        .catch(function () {
          /* Network failure — degrade to the regular product page. */
          window.location.href = productUrl;
        });
    }

    function close() {
      modal.hidden = true;
      document.body.classList.remove('fpk-qv-open');
      if (lastFocus && typeof lastFocus.focus === 'function') {
        try { lastFocus.focus(); } catch (e) { /* ignore */ }
      }
    }

    triggers.forEach(function (t) {
      t.addEventListener('click', function (e) {
        /* Every click trigger (image link, title link, Quick view button)
           inside the same card reads from a single data-source: the card
           itself. closest() walks up to [data-fpk-card] for the data. */
        var card = t.closest('[data-fpk-card]');
        if (!card) return;
        var handle = card.getAttribute('data-product-handle');
        if (!handle) return;
        e.preventDefault();
        var url = card.getAttribute('data-product-url') || t.getAttribute('href') || ('/products/' + handle);
        open(handle, url, card);
      });
    });

    modal.querySelectorAll('[data-qv-close]').forEach(function (el) {
      el.addEventListener('click', close);
    });

    /* Keyboard handling: Escape closes, Tab traps focus inside the panel. */
    document.addEventListener('keydown', function (e) {
      if (modal.hidden) return;
      if (e.key === 'Escape') {
        e.preventDefault();
        close();
        return;
      }
      if (e.key !== 'Tab') return;
      var focusables = getFocusable(modal);
      if (!focusables.length) return;
      var first = focusables[0];
      var last = focusables[focusables.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault(); last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault(); first.focus();
      }
    });
  }

  /* ---------------------------------------------------------- Init ------- */

  function init(root) {
    initCarousel(root);
    initQuickview(root);
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('.featured-products-kuma').forEach(init);
  }

  document.addEventListener('shopify:section:load', function (e) {
    var target = e.target;
    if (target && target.querySelector && target.querySelector('.featured-products-kuma')) {
      initAll(target);
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }
})();
